import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '100%',
      minHeight: '550px',
    },

    button: {
      marginRight: theme.spacing(1),
    },
    backButton: {
      marginRight: theme.spacing(1),
    },
    completed: {
      display: 'inline-block',
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },

    headerRoot: {
      alignItems: 'center',
      borderBottom: theme.palette.border.default,
      display: 'flex',
      justifyContent: 'space-between',
      padding: '10px 20px 10px 32px',

      '& .MuiCardHeader-content': {
        '& .MuiCardHeader-title': {
          color: theme.palette.text.primary,
          fontSize: 14,
          fontWeight: 'bold',
        },
      },

      '& .MuiCardHeader-action': {
        margin: 0,
      },
    },

    cardActions: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      margin: '0 auto',
      padding: '16px 32px 66px',
      width: '100%',
    },

    cardHeaderActions: {
      padding: 5,
    },

    actionButtons: {
      margin: '0 0 0 40px',
    },

    stepperContainer: {
      width: '100%',
    },

    flexEnd: {
      justifyContent: 'flex-end',
    },

    content: {
      height: '100%',
      padding: '24px 32px',
    },

    footer: {
      backgroundColor: '#F6F6F6',
      padding: '16px 32px',
    },

    linkButton: {
      textDecoration: 'underline',
    },
  };
});

export default useStyles;
